/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rich_Dusty_Fox_AidInputs */

const en_rich_dusty_fox_aid = /** @type {(inputs: Rich_Dusty_Fox_AidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} keywords`)
};

const de_rich_dusty_fox_aid = /** @type {(inputs: Rich_Dusty_Fox_AidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Keywords`)
};

/**
* | output |
* | --- |
* | "{count} keywords" |
*
* @param {Rich_Dusty_Fox_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_dusty_fox_aid = /** @type {((inputs: Rich_Dusty_Fox_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Dusty_Fox_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_dusty_fox_aid(inputs)
	return de_rich_dusty_fox_aid(inputs)
});